/* EVE'S SKIN, GSAP scroll choreography (progressive enhancement) */
(function () {
  'use strict';
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  gsap.registerPlugin(ScrollTrigger);

  /* re-measure pinned sections once all images have loaded */
  window.addEventListener('load', function () { ScrollTrigger.refresh(); });

  /* ---------- hero drift ---------- */
  var heroContent = document.querySelector('.hero-content');
  if (heroContent) {
    gsap.to(heroContent, {
      yPercent: 18, opacity: 0.35, ease: 'none',
      scrollTrigger: { trigger: '.hero', start: 'bottom 90%', end: 'bottom 30%', scrub: true }
    });
  }

  /* ---------- scrub text fill (statement + section headings) ---------- */
  document.querySelectorAll('.fill-text').forEach(function (el) {
    gsap.to(el, {
      backgroundPositionX: '0%', ease: 'none',
      scrollTrigger: { trigger: el, start: 'top 82%', end: 'top 38%', scrub: 0.6 }
    });
  });

  /* ---------- botanicals: line-grow + rise ---------- */
  var botItems = gsap.utils.toArray('.bot-item');
  if (botItems.length) {
    botItems.forEach(function (item, i) {
      gsap.fromTo(item, { y: 54, opacity: 0 }, {
        y: 0, opacity: 1, duration: 1.1, ease: 'power4.out', delay: i * 0.09,
        scrollTrigger: { trigger: item, start: 'top 86%' }
      });
      /* animated top hairline */
      var line = document.createElement('span');
      line.style.cssText = 'position:absolute;top:0;left:0;height:1px;width:100%;background:var(--lavender-deep);transform:scaleX(0);transform-origin:left;';
      item.style.position = 'relative';
      item.appendChild(line);
      gsap.to(line, {
        scaleX: 1, duration: 1.3, ease: 'power4.out', delay: i * 0.09,
        scrollTrigger: { trigger: item, start: 'top 86%' }
      });
    });
  }

  /* ---------- testimonial rail: pinned horizontal scrub (desktop) ---------- */
  var rail = document.querySelector('.t-rail');
  var tSec = document.querySelector('.t-sec');
  if (rail && tSec) {
    ScrollTrigger.matchMedia({
      '(min-width: 900px)': function () {
        var getDist = function () { return Math.max(0, rail.scrollWidth - rail.parentElement.offsetWidth); };
        var tween = gsap.to(rail, {
          x: function () { return -getDist(); },
          ease: 'none',
          scrollTrigger: {
            trigger: tSec, start: 'top top', end: function () { return '+=' + (getDist() + 300); },
            pin: true, scrub: 1, invalidateOnRefresh: true, anticipatePin: 1
          }
        });
        var prog = document.querySelector('.t-progress i');
        if (prog) {
          gsap.to(prog, {
            scaleX: 1, ease: 'none',
            scrollTrigger: { trigger: tSec, start: 'top top', end: function () { return '+=' + (getDist() + 300); }, scrub: 1 }
          });
        }
        return function () { tween.scrollTrigger && tween.scrollTrigger.kill(); };
      }
    });
  }

  /* ---------- campaign banner parallax ---------- */
  var camp = document.querySelector('.campaign-media img');
  if (camp) {
    gsap.fromTo(camp, { yPercent: -10, scale: 1.12 }, {
      yPercent: 10, scale: 1.02, ease: 'none',
      scrollTrigger: { trigger: '.campaign', start: 'top bottom', end: 'bottom top', scrub: 1 }
    });
  }

  /* ---------- ritual steps ---------- */
  var steps = gsap.utils.toArray('.ritual-step');
  steps.forEach(function (s, i) {
    gsap.from(s, {
      y: 70, opacity: 0, duration: 1.15, ease: 'power4.out', delay: i * 0.12,
      scrollTrigger: { trigger: s.parentElement, start: 'top 78%' }
    });
    gsap.from(s.querySelector('.rnum'), {
      x: -24, opacity: 0, duration: 1.2, ease: 'power4.out', delay: 0.25 + i * 0.12,
      scrollTrigger: { trigger: s.parentElement, start: 'top 78%' }
    });
  });

  /* ---------- edit cards frame parallax ---------- */
  gsap.utils.toArray('.edit-card img').forEach(function (img) {
    gsap.fromTo(img, { yPercent: -6 }, {
      yPercent: 6, ease: 'none',
      scrollTrigger: { trigger: img.closest('.edit-card'), start: 'top bottom', end: 'bottom top', scrub: 1.4 }
    });
  });

  /* ---------- story page chapters ---------- */
  gsap.utils.toArray('.chapter').forEach(function (ch) {
    var media = ch.querySelector('.mframe img');
    if (media) {
      gsap.fromTo(media, { scale: 1.12 }, {
        scale: 1, ease: 'none',
        scrollTrigger: { trigger: ch, start: 'top 85%', end: 'top 20%', scrub: 0.8 }
      });
    }
  });
  gsap.utils.toArray('.value-row').forEach(function (row, i) {
    gsap.from(row, {
      x: -34, opacity: 0, duration: 1, ease: 'power4.out', delay: (i % 4) * 0.08,
      scrollTrigger: { trigger: row, start: 'top 88%' }
    });
  });
})();
